import { isHttpError } from '@App/exceptions/HttpError'

// Suppress Errors Coming From Cancelled API calls
export const handleAbortedException = (error: any) => {
    if (!(isHttpError(error) && error.statusCode === 'ERR_CANCELED')) {
        throw error
    }
}
